import CustomerSupportRequests from './CustomerSupportRequests';
import './CustomerSupportRequests.scss';

export default CustomerSupportRequests;
